import { isMobileFunc } from '@/helper/functions';
import clsx from 'clsx';

function Modal({ title = null, onOpenChange, width = '520', height = '520', className, children }) {
  const closeModal = (e) => {
    if (e.target.id == 'modal') {
      onOpenChange(false);
    }
  };
  return (
    <div
      id="modal"
      onClick={closeModal}
      className="z-50 bg-[#070707cc] backdrop-opacity-disabled w-screen h-[100dvh] fixed inset-0 flex items-center justify-center max-sm:items-end"
    >
      <div
        style={{
          width: `${width}px`,
          // height: `${height}px`,
          height: 'fit-content',
          // minHeight: `${height}px`,
        }}
        className={clsx(
          className,
          isMobileFunc() ? 'animate-enter-top' : `animate-enter`,
          'flex flex-col items-center overflow-hidden bg-white dark:bg-blackFont-800 rounded-2xl max-sm:rounded-3xl max-sm:rounded-b-none max-sm:w-screen relative',
        )}
      >
        {title && (
          // <section className="flex items-center justify-center w-full h-10">
          //   <p className="text-2xl max-sm:text-lg font-extrabold text-text-hard">{title}</p>
          //   <span
          //     id="modal-btn"
          //     onClick={() => onOpenChange(false)}
          //     className="absolute left-7 top-7 w-8 h-8 transition-all flex items-center justify-center rounded-xl cursor-pointer hover:bg-light-grey/30"
          //   >
          //     <svg className="w-6 h-6">
          //       <use href="#close"></use>
          //     </svg>
          //   </span>
          // </section>
          <div className="w-full flex flex-col gap-6">
            <div className="flex items-center justify-between w-full">
              <span className="font-bold text-blackFont-800 dark:text-white text-lg">{title}</span>
              <button
                id="modal-btn"
                className="p-2 hover:bg-blackFont-50 dark:hover:bg-blackFont-700 rounded-full transition-all z-50 text-blackFont-800 dark:text-white"
                onClick={() => onOpenChange(false)}
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18 6L6 18M6 6L18 18"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <hr className="w-full border-blackFont-100 dark:border-blackFont-700" />
          </div>
        )}
        {children}
      </div>
    </div>
  );
}

export default Modal;
